import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";


export async function searchProducts({ state, commit }, model_id = null) {
  let requestParameters = {
    params: state.params
  };

  if (model_id !== null) {
    requestParameters.params.model_id = model_id;
  }

  await $http.get("/api/lista-productos", requestParameters).then(response => {
    commit("setStateProductspagination", response.data.data);
    commit("setStateProducts", response.data.data.data);
    commit("setTitleBranchoffice", response.data.data.data);
  });
}

export async function justifyAvailability({ state, commit }, parameters) {

  let params = {
    branchoffice_id: parameters.branchoffice_id,
    voucher_type: 4,
    filter: "",
    model_id: 1,
    product_id: parameters.product_id,
    closed: false
  };

  await $http
    .get("/api/documentos-diponibilidad", { params })
    .then(response => {
      commit("setJustify_availability", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function availability({ state, commit }, product_id) {
  await $http
    .get(`/api/diponibilidad-sedes/${product_id}`)
    .then(response => {
        console.log( response.data)
      commit("setavAilability_totals", response.data[0]);
      commit("setAvailability", response.data[1]);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function updatelocation({ state }) {
  // let selected_branchoffice_warehouse = JSON.parse(localStorage.selected_branchoffice_warehouse)

  var params = state.params_location;
  try {
    var response = await $http.put(`/api/actualizar-localizacion`, params);
    if (response.data.status) {
      Notification.success({
        title: "Exito!",
        message: response.data.message,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
    } else {
      Notification.error({
        title: "Error!",
        message: response.data.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    }
  } catch (error) {
    Notification.error({
      title: "Error!",
      message: "Error al actualizar",
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  }
}

export async function fetchContacts({commit, state},requestParameters = {params: state.params_contacts}) {
    await $http.get('/api/terceros-lite', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })
}
export async function fetchHistoryProductsContacts({ state, commit }){
    state.params_history_products.loading = true;
    state.history_products = [];

    await $http.get('/api/historico-productos-terceros', {params : state.params_history_products})
        .then((response) => {
            state.params_history_products.loading = false;
            commit('setHistoryReportProductsContact', response.data.data)
        })
        .catch((error) => {
            state.params_history_products.loading = false;
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
export async function downloadPdfInventory({state}, data) {

    let name = `${data.nro_voucher} ${data.nro_doc}.pdf`;
    await $http({
        url: '/api/documentos/descargar-pdf/'+ data.document_id,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        state.file_name = '/storage/pdf/'+name ;
        state.show_pdf = true ;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
}
export async function getBranchofficeWarehouse({ state, commit }, id) {
    await $http
        .get(`/api/get-branch-ware/${id}`)
        .then(response => {
            commit("setBranchofficeWarehouse", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.response.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

//Obtener las sedes
export async function fetchBranchOfficesWarehouses({commit, state}) {
    await $http
        .get('/api/bodegas-sedes', {params: {branchoffice_id: state.params.branchoffice_id}})
        .then(response => {
            commit('setBranchOfficesWarehouses', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
            commit('BranchOfficeError', error.message);
        });
}



// WEBPACK FOOTER //
// ./src/modules/availability-inquiry/actions.js